import React from "react";
import { RiMapPinUserFill, RiChat3Line, RiStarFill } from "react-icons/ri";
import useArtisanContext from "../../hooks/useArtisanContext";

import useChatContext from "../../hooks/useChatContext";

import { SubHeader } from "./Header";

const AcceptedProvider = () => {
  const { acceptedProvider, loadingAcceptedProvider } = useArtisanContext();

  const { handleinitiateChat } = useChatContext();

  const handleChatInitiation = (receiverId) => {
    handleinitiateChat(receiverId);
  };

  return (
    <>
      <div className=" pb-5">
        <SubHeader title={"Requested service"} />
      </div>
      <h2 className="py-3 border-b">
        List of Merchant interest in your request
      </h2>

      {acceptedProvider?.length > 0 &&
        acceptedProvider.map((provider) => {
          const receiver = provider?.receiver;
          const service = receiver?.services[0];
          return (
            <div
              key={provider.id}
              className="flex justify-between py-5 border-b items-center "
            >
              <div className="flex gap-5 items-center">
                <img
                  className="object-cover w-14 h-14 rounded-full"
                  src={service.image}
                  alt=""
                />
                <div className="space-y-1">
                  <p className="flex items-center gap-2 font-normal text-xs">
                    <span>{service.business_name}</span>
                    <span className="w-fit border border-secondary rounded-md p-1 text-center text-[10px]">
                      {service.service_category.category}
                    </span>
                    <span className="text-green-700">
                      <RiStarFill />
                    </span>
                  </p>
                  <div className="flex items-center gap-2">
                    <p className="text-primary text-lg">
                      <RiMapPinUserFill />
                    </p>
                    <p className="text-[10px] opacity-70">
                      {receiver?.address}
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex gap-1 h-fit">
                <button
                  onClick={() => handleChatInitiation(receiver?.id)}
                  className="bg-secondary p-2 rounded-md"
                >
                  <RiChat3Line />
                </button>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default AcceptedProvider;
